import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { VideoPlayer } from "../../components/VideoPlayer/VideoPlayer";
import { BannerContainer } from "./BannerContainer";
import "./Hero.scss";
/**
 *
 * Hero v1 component used in Loyalty
 */
export const Hero = ({ img, mobileImg, bottomMobileImg, headerContent, loggedTitle, unloggedTitle, loggedContent, unloggedContent, isLogged, fullscreen = true, isVideo = false, videoMobile, videoTablet, videoDesktop, containerClassName, bannerContainerClassName, }) => {
    const containerClass = classNames("hero", containerClassName, {
        "hero--logged": isLogged,
        "hero--not-fullscreen": !fullscreen,
    });
    const bannerContainerProps = {
        bottomMobileImg,
        fullscreen,
        headerContent,
        isLogged,
        loggedTitle,
        unloggedTitle,
        loggedContent,
        unloggedContent,
        className: bannerContainerClassName,
    };
    const mobileBackgroundContainer = classNames("hero__img", "hero__imgMobile");
    if (!isVideo) {
        const backgroundStyle = {
            backgroundImage: `url(${img})`,
        };
        return (_jsxs("div", { className: containerClass, style: backgroundStyle, "data-testid": "hero-banner", children: [_jsx("div", { className: mobileBackgroundContainer, "data-testid": "hero__mobile-background-container", children: _jsx("img", { src: mobileImg, alt: "" }) }), _jsx(BannerContainer, { ...bannerContainerProps })] }));
    }
    return (_jsxs("div", { className: containerClass, "data-testid": "hero-banner", children: [_jsx(VideoPlayer, { preventDownload: true, showControls: false, preventMainPlayButtonClick: true, loop: true, autoPlay: true, mobileSrc: videoMobile, tabletSrc: videoTablet, desktopSrc: videoDesktop || "" }), _jsx(BannerContainer, { ...bannerContainerProps })] }));
};
//# sourceMappingURL=Hero.js.map